import { useState } from 'react';
import { Callout } from 'seagull';
import { AnchorLogo } from 'seagull/icons';
import { useLocation } from 'react-router-dom';
import { useIoContext } from "../../../contexts";
import OTPStep from "./Steps/OTP";
import EmailStep from "./Steps/Email";
import PasswordStep from "./Steps/Password";
import { FormTitle } from "../components/FormComponents";
import { getIsSimplifiedLogin, getTheNextStep } from "./LoginScreen.utils";
import UnauthorizedPageContainer from "../components/UnauthorizedPageContainer";
import { useSetDocumentTitle } from "../../../hooks/useSetDocumentTitle";
import styles from "./LoginScreen.module.scss";
import OTPForm from "./Steps/OTPForm";
import { useFeatureFlags } from "../../../hooks/useFeatureFlags";
import { LoginFlow } from "./LoginScreen.types";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function getClientViewURL(pathname) {
  return "".concat(pathname, "?view=client");
}
export function LoginScreen() {
  const location = useLocation();
  const locationState = location.state;
  const {
    OTP_SIGNUP
  } = useFeatureFlags();
  const [currentStep, setCurrentStep] = useState({
    step: LoginFlow.Email
  });
  const [hasPassword, setHasPassword] = useState(false);
  const {
    cookies
  } = useIoContext();
  const hasVendorAccount = cookies.getHasVendorAccountFromUserDetailsCookie();
  const isSimplifiedLogin = getIsSimplifiedLogin({
    setLoginFlow: locationState === null || locationState === void 0 ? void 0 : locationState.setLoginFlow,
    locationSearch: location.search,
    hasVendorAccount: hasVendorAccount !== null && hasVendorAccount !== void 0 ? hasVendorAccount : undefined
  });
  useSetDocumentTitle('Anchor Login');
  function getTitleMP() {
    return /*#__PURE__*/_jsx(FormTitle, {
      children: isSimplifiedLogin ? /*#__PURE__*/_jsx(AnchorLogo, {
        className: styles.logo
      }) : 'Welcome to Anchor'
    });
  }
  return /*#__PURE__*/_jsxs(UnauthorizedPageContainer, {
    animatedBackground: !isSimplifiedLogin,
    hideBanner: isSimplifiedLogin,
    testId: "login-form",
    otpLayout: (currentStep.step === LoginFlow.OTP || currentStep.step === LoginFlow.EmailVerification) && OTP_SIGNUP,
    children: [currentStep.step === LoginFlow.Email && /*#__PURE__*/_jsx(EmailStep, {
      onSubmit: _ref => {
        let {
          email,
          flow
        } = _ref;
        setCurrentStep({
          step: getTheNextStep({
            flow,
            isSimplifiedLogin,
            OTP_SIGNUP: OTP_SIGNUP !== null && OTP_SIGNUP !== void 0 ? OTP_SIGNUP : false
          }),
          email
        });
        setHasPassword(flow === LoginFlow.Password);
      },
      titleMP: getTitleMP(),
      subtitleMP: isSimplifiedLogin ? /*#__PURE__*/_jsx(FormTitle, {
        children: isSimplifiedLogin ? 'Welcome to Anchor' : 'Login to continue'
      }) : locationState !== null && locationState !== void 0 && locationState.sessionTimeout ? /*#__PURE__*/_jsx(Callout, {
        hideIcon: true,
        intent: "error",
        "data-testid": "session-timeout-error",
        children: "You have been automatically signed out due to inactivity."
      }) : null,
      simplified: isSimplifiedLogin
    }), currentStep.step === LoginFlow.Password && /*#__PURE__*/_jsx(PasswordStep, {
      email: currentStep.email,
      onClickRequestOTP: () => {
        setCurrentStep({
          step: LoginFlow.OTP,
          email: currentStep.email
        });
      },
      titleMP: getTitleMP(),
      subtitleMP: isSimplifiedLogin ? /*#__PURE__*/_jsx(FormTitle, {
        children: "Login to continue"
      }) : null
    }), currentStep.step === LoginFlow.OTP && (OTP_SIGNUP ? /*#__PURE__*/_jsx(OTPForm, {
      email: currentStep.email,
      flow: LoginFlow.OTP,
      onBack: () => setCurrentStep({
        step: LoginFlow.Email
      }),
      shouldRequestOTP: true
    }) : /*#__PURE__*/_jsx(OTPStep, {
      titleMP: getTitleMP(),
      subtitleMP: /*#__PURE__*/_jsx(FormTitle, {
        children: "Enter confirmation code"
      }),
      email: currentStep.email,
      hasPassword: hasPassword,
      simplified: isSimplifiedLogin
    })), currentStep.step === LoginFlow.EmailVerification && /*#__PURE__*/_jsx(OTPForm, {
      email: currentStep.email,
      flow: LoginFlow.EmailVerification,
      onBack: () => setCurrentStep({
        step: LoginFlow.Email
      }),
      shouldRequestOTP: true
    })]
  });
}